// Written in this round about way for babel-transform-imports
import Route from "react-router/es/Route";

export default Route;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/Route.js
// module id = 315
// module chunks = 0